// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-comments {\n  height: 250px;\n  overflow-y: scroll;\n}\n\n", ""]);
// Exports
module.exports = exports;
